import Dexie, { IndexableType } from 'dexie'

import { getDatabase } from './instance'
import {
  AssignPlayerOnPitchTable,
  EventIncidentsQueueTable,
  EventSettingsTable,
  IncidentsRequirePointingPositionTable,
  PlayersSecondaryPositionTable,
} from './table'
import { Tables } from './tables'

export function getTable(tableName: Tables): Dexie.Table {
  return getDatabase().table(tableName)
}

export async function upsertTableItem<T extends Record<string, unknown>>(
  database: Dexie,
  tableName: Tables,
  primaryKey: IndexableType,
  item: T,
): Promise<void> {
  const table = database.table(tableName)

  await database.transaction('rw', table, async () => {
    const existingData = await table.get(primaryKey)
    const primaryKeyName = table.schema.primKey.keyPath as string

    const mergedData = {
      ...existingData,
      ...item,
    }

    for (const key of Object.keys(mergedData)) {
      if (mergedData[key] === undefined) delete mergedData[key]
    }

    return table.put({
      ...mergedData,
      [primaryKeyName]: primaryKey,
    })
  })
}

export async function clearEventData(eventId: number): Promise<void> {
  const database = getDatabase()
  await database.transaction(
    'rw',
    [
      Tables.EVENT_INCIDENTS_QUEUE,
      Tables.ASSIGN_PLAYER_ON_PITCH,
      Tables.EVENT_SETTINGS,
      Tables.INCIDENTS_REQUIRE_POINTING_POSITION,
      Tables.PLAYER_SECONDARY_POSITION,
    ],
    async () => {
      await Promise.all([
        EventIncidentsQueueTable.remove(eventId),
        AssignPlayerOnPitchTable.remove(eventId),
        EventSettingsTable.remove(eventId),
        IncidentsRequirePointingPositionTable.remove(eventId),
        PlayersSecondaryPositionTable.remove(eventId),
      ])
    },
  )
}
